import { pxToRem, imageClassName } from '@archipro-design/aria';
import type { StyleRule } from '@archipro-design/aria';

export const PrimaryImageDesktopContainer: StyleRule<{
    isVideo: boolean;
    width: number;
    height: number;
    isError: boolean;
}> = ({ theme, width, height, isVideo, isError }) => ({
    width: pxToRem(width),
    height: pxToRem(height),
    margin: `0 auto`,
    display: 'block',
    maxWidth: '100%',
    position: 'relative',

    [`& .${imageClassName}`]: {
        height: '100%',
        '& img': {
            background:
                isVideo && !isError
                    ? theme.siteVariables.colors.primitive.black
                    : isVideo && isError
                    ? theme.siteVariables.colors.white['200A']
                    : 'transparent',
            height: '100%',
        },
    },
    [theme.screen.tablet]: {
        display: 'block',
    },
});

export const ImageCaption: StyleRule = () => ({ textAlign: 'center' });
